import {
  eachDayOfInterval,
  format,
  getDay,
  getHours,
  max,
  min,
  parse,
} from 'date-fns';
import ja from 'date-fns/locale/ja';

import { Days } from '@/domain/models/Day';
import { Hours } from '@/domain/models/Hour';
import { ValidationError } from '@/lib/exception';

export class DateDomainService {
  static range(from: Date, to: Date): Date[] {
    return eachDayOfInterval({ start: from, end: to });
  }

  static min(dateList: Date[]): Date {
    return min(dateList);
  }

  static max(dateList: Date[]): Date {
    return max(dateList);
  }

  static rangeFromMinToMax(dateList: Date[]): Date[] {
    const min = this.min(dateList);
    const max = this.max(dateList);
    return this.range(min, max);
  }

  static getDay(date: Date): Days {
    const dayIndex = getDay(date);
    return Days[dayIndex];
  }

  static getHour(date: Date): Hours {
    const hour = getHours(date) as Hours;
    if (!Hours.includes(hour)) {
      throw new ValidationError('正しい時間でありません');
    }
    return hour;
  }

  static datetimeFormat(date: Date): string {
    return format(date, 'yyyy-MM-dd HH:mm', { locale: ja });
  }
  static datetimeFormatJa(date: Date): string {
    return format(date, 'yyyy年MM月dd日HH時mm分', { locale: ja });
  }

  static datetimeNoColonFormat(date: Date): string {
    return format(date, 'yyyyMMddHHmm', { locale: ja });
  }

  static parseNoColonFormat(str: string): Date {
    return parse(str, 'yyyyMMddHHmm', new Date());
  }

  static parseISOFormat(str: string): Date {
    return parse(str, "yyyy-MM-dd'T'HH:mm:ssxxx", new Date());
  }

  static timeFormat(date: Date): string {
    return format(date, 'HH:mm', { locale: ja });
  }

  static formatHHmm(date: Date): string {
    return format(date, 'HHmm', { locale: ja });
  }

  static format(date: Date): string {
    return format(date, 'yyyy-MM-dd', { locale: ja });
  }
  static formatDay(date: Date): string {
    return format(date, 'yyyy/MM/dd', { locale: ja });
  }

  static shortFormat(date: Date): string {
    return format(date, 'MM/dd', { locale: ja });
  }

  static yyyymmdd(date: Date): string {
    return format(date, 'yyyyMMdd', { locale: ja });
  }

  static formatCustom(date: Date, formatStr: 'yyyy/MM/dd(E)HH:mm'): string {
    return format(date, formatStr, { locale: ja });
  }
}
